
export const multipliersSQL = (origin) => {
    const sql =  `  /* EM - Select data for multipler table */
    SELECT impacted, origin, multiplier, index FROM prime_brisbane_em_multipliers
    WHERE origin = '${origin}'
    ORDER BY index ASC`
    //console.log('sql', sql)
    return sql;
  }


// WEBPACK FOOTER //
// ./src/sql/economicModelQueries.js